import React from 'react';
import ReactDOM from 'react-dom/client';
import {getDataFromServer} from "./service.js";
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
getDataFromServer().then((dataFromServer) =>
root.render(
  <div>
    <App listFromServer={dataFromServer}/>
  </div>
));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

